/** @format */
import {MONTH_DAYS_MAX, MONTH_DAYS_MIN, WEEK_DAYS} from '../../../const';

/**
 * Принимает строки типа "7 дней" или "28 дней".
 * 7 → "За неделю", 28-31 → "За месяц", другие → пустая строка.
 * @param periodDays
 */

const getPeriodText = (periodDays?: string): string => {
  if (!periodDays) {
    return '';
  }

  const parsed = parseInt(periodDays);

  if (Number.isNaN(parsed)) {
    return '';
  }

  if (parsed >= MONTH_DAYS_MIN && parsed <= MONTH_DAYS_MAX) {
    return 'За месяц';
  }

  if (parsed === WEEK_DAYS) {
    return 'За неделю';
  }

  return '';
};

export {getPeriodText};
